require('./reports.style.scss');
const reportsModule = angular.module('com.comtrade.nutanix.backup.reports', []);

reportsModule.constant('config', require('../../app.constants'));

reportsModule.component('reports', require('./reports.component'));
reportsModule.component('editReport', require('./dialogs/editReport/editReport.component'));
reportsModule.component('scheduleReportDialog', require('./dialogs/scheduleReportDialog/scheduleReportDialog.component'));
reportsModule.component('generateReportDialog', require('./dialogs/generateReportDialog/generateReportDialog.component'));
reportsModule.component('reportImportDialog', require('./dialogs/reportImportDialog/reportImportDialog.component'));
reportsModule.component('pivotTableComponent', require('../../../shared/ctxPivotTable/ctxPivotTable.component'));
reportsModule.component('pivotTagFilterComponent', require('../../../shared/ctxPivotTable/ctxPivotTagFilter.component'));

reportsModule.service('reportsPersistence', require('./reports.persistence.service'));

module.exports = reportsModule;


// WEBPACK FOOTER //
// ./src/azurebackup/views/reports/reports.module.js